import React from 'react'
import clsx from 'clsx'

import './Button.scss'

const Button = ({
   children,
   className,
   variant,
   color,
   onClick,
   type = 'button',
   size = 'sm',
   isDarkTheme = false,
   fullWidth,
}) => {
   return (
      <button
         className={clsx(
            'Button',
            `Button--${variant}`,
            `Button--${color}`,
            `Button--${size}`,
            isDarkTheme && `Button--dark`,
            fullWidth && `Button--full`,
            className
         )}
         onClick={onClick}
         type={type}
      >
         {children}
      </button>
   )
}

export default Button
